// extracted by mini-css-extract-plugin
export default {"btn":"styles_btn__CejBE","cancelBtn":"styles_cancelBtn__pxqKu"};